"use client";

import { Typography } from "@material-tailwind/react";
import { StarIcon } from "@heroicons/react/24/solid";
import SkillCard from "./SkillCard";

const SKILLS = [
  {
    icon: StarIcon,
    title: "กฎหมายบังคับ",
    children:
      "สินค้าประกันภัยต้องซื้อซ้ำในทุกปี กฎหมายบังคับ เช่น พ.ร.บ.รถ ถ้าไม่ซื้อก็ไม่สามารถต่อภาษีรถประจำปีได้",
  },
  {
    icon: StarIcon,
    title: "ลงทุนน้อย",
    children:
      "สินค้าประกันภัยไม่ต้องนำเงินมาลงทุนสต๊อกสินค้า หมดปัญหาสินค้าค้างสต๊อกขายไม่ได้ เงินทุนจม ไม่ต้องกลัวเจ๊ง",
  },
  {
    icon: StarIcon,
    title: "โอนความเสี่ยง",
    children:
      "สินค้าประกันภัยไม่ต้องสาธิต ซื้อเพื่อโอนความเสี่ยงภัยที่อาจเกิดขึ้นกับการใช้ชีวิตประจำวัน",
  },
  {
    icon: StarIcon,
    title: "สินค้าที่หลากหลาย",
    children:
      "ยอดขายเติบโตขึ้นทุกปี สินค้าประกันภัยมีหลายประเภทให้เลือกซื้อตามความเหมาะสมกับการใช้ชีวิตประจำวัน",
  },
  {
    icon: StarIcon,
    title: "ได้รับความรู้",
    children:
      "เป็นอาชีพที่มีเกียรติ ต้องมีความรู้ และมีใบอนุญาตบัตรนายหน้าประกันภัย",
  },
  {
    icon: StarIcon,
    title: "ทำได้ทุกอาชีพ",
    children: "ทำได้ทุกอาชีพ ไม่จำกัดวุฒิการศึกษา",
  },
];

export function Highlight() {
  return (
    <section className="px-8 mt-28">
      <div className="container mx-auto mb-20 text-center">
        <Typography variant="h2" color="blue-gray" className="mb-4 font-noto">
          💖 6 จุดเด่น ธุรกิจประกันภัย
        </Typography>
      </div>
      <div className="container mx-auto grid grid-cols-1 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
        {SKILLS.map((props, idx) => (
          <SkillCard key={idx} {...props} />
        ))}
      </div>
    </section>
  );
}

export default Highlight;
